import { render, staticRenderFns } from "./Damages.vue?vue&type=template&id=4f3783e1&scoped=true"
import script from "./Damages.vue?vue&type=script&lang=js"
export * from "./Damages.vue?vue&type=script&lang=js"
import style0 from "./Damages.vue?vue&type=style&index=0&id=4f3783e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3783e1",
  null
  
)

export default component.exports